
<template>
    <div class="maincontainer">
        <h1>保養小技巧</h1>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'SkincareTipsPage',
  }
  </script>
  
  <style scoped>
.maincontainer {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}

  </style>
  